import React, { useState } from 'react';
import Styled from '../styles/AdminFVContainer.styled';
import StyledForm from '../styles/FormFV.styled';
import { MdClose } from 'react-icons/md';
import Colors from 'enums/Colors';
import ReactQuill from 'react-quill';
import { Input, InputNumber } from 'antd';
import * as Yup from 'yup';
import { IFormFVUnit } from '../interfaces/components/IFormFVUnit';

const validationSchema = Yup.object().shape({
    title: Yup.string().required('Título é obrigatório').max(200, 'Máximo de 200 caracteres'),
    url: Yup.string().required('URL é obrigatória').max(50, 'Máximo de 50 caracteres'),
    alt_url: Yup.string().max(100, 'Máximo de 100 caracteres'),
});

const FormFVUnit = ({ formVisible, handleSubmit, setForm, setFormVisible, form, handleChange, loading }: IFormFVUnit) => {
    const [errors, setErrors] = useState<any>({});

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await validationSchema.validate(form, { abortEarly: false });
            setErrors({});
            handleSubmit(e);
        } catch (err: any) {
            if (err.inner) {
                const formErrors: any = {};
                err.inner.forEach((validationError: any) => {
                    formErrors[validationError.path] = validationError.message;
                });
                setErrors(formErrors);
            }
        }
    };

    return (
        <StyledForm.FormFerramentaVideo onSubmit={onSubmit} active={formVisible}>
            <MdClose
                style={{ cursor: 'pointer', alignSelf: 'flex-end', justifySelf: 'flex-end' }}
                size={32}
                color={Colors.Blue}
                onClick={() => setFormVisible(false)}
            />
            <Styled.FormGroup>
                <Styled.Label htmlFor="title">Título</Styled.Label>
                <Input
                    size="large"
                    name="title"
                    id="title"
                    value={form.title}
                    onChange={handleChange}
                    maxLength={200}
                    showCount
                    required
                    placeholder="Digite o título"
                />
                {errors.title && <Styled.ErrorText>{errors.title}</Styled.ErrorText>}
            </Styled.FormGroup>
            <Styled.FormGroup>
                <Styled.Label htmlFor="nomenclature">Nomeclatura</Styled.Label>
                <Input
                    size="large"
                    name="nomenclature"
                    id="nomenclature"
                    value={form.nomenclature}
                    onChange={handleChange}
                    maxLength={200}
                    showCount
                    placeholder="Digite a nomenclatura"
                />
                {errors.nomenclature && <Styled.ErrorText>{errors.nomenclature}</Styled.ErrorText>}
            </Styled.FormGroup>
            <Styled.FormGroup>
                <Styled.Label htmlFor="description">Descrição</Styled.Label>
                <ReactQuill
                    value={form.description}
                    onChange={v => {
                        setForm((prev: any) => ({ ...prev, description: v }));
                    }}
                    placeholder="Digite a descrição"
                    style={{
                        backgroundColor: 'white',
                        color: 'black',
                    }}
                />
            </Styled.FormGroup>
            <Styled.FormTwoGrid>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="url">URL</Styled.Label>
                    <Input
                        size="large"
                        name="url"
                        id="url"
                        value={form.url}
                        onChange={handleChange}
                        required
                        maxLength={50}
                        showCount
                        placeholder="Digite a URL"
                    />
                    {errors.url && <Styled.ErrorText>{errors.url}</Styled.ErrorText>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="altUrl">Texto alternativo da URL</Styled.Label>
                    <Input
                        size="large"
                        name="altUrl"
                        id="altUrl"
                        value={form.altUrl}
                        onChange={handleChange}
                        maxLength={100}
                        showCount
                        placeholder="Digite o texto alternativo da URL"
                    />
                    {errors.altUrl && <Styled.ErrorText>{errors.altUrl}</Styled.ErrorText>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="description">Ordenação</Styled.Label>
                    <InputNumber min={1} max={10} value={form.ordem} onChange={value => setForm((prev: any) => ({ ...prev, ordem: value }))} />
                </Styled.FormGroup>
            </Styled.FormTwoGrid>

            <Styled.Button type="submit" disabled={loading}>
                {loading ? <div className="loaderConteudo" style={{ width: '26px' }} /> : form.id > 0 ? 'Atualizar Unidade' : 'Criar Unidade'}
            </Styled.Button>
        </StyledForm.FormFerramentaVideo>
    );
};

export default FormFVUnit;
